import { Price } from '../../components/Price';
import { useGeneralInfo } from '../../hooks';

export function PriceContainer() {
  const {
    price: { price, priceInfo, discount },
  } = useGeneralInfo();

  return <Price priceInfo={priceInfo} price={price} discount={discount} />;
}
